import React from "react";
import { useState } from "react";
import { ReactComponent as UpperArrow } from "assets/images/icons/upper-arrow.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import { ReactComponent as CreditCardIcon } from "assets/images/icons/credit-card.svg";
import { config as globalConfig } from "../../../../../../../config";
import * as globalUtils from "../../../../../../../helpers/utils";
import { Button } from "primereact/button";
import StyleWrapper from "../style";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { InputNumber } from "primereact/inputnumber";
import config from "../../../../../helpers/config";
import { useTranslation } from "react-i18next";


const OtherDriverDetails = (props) => {
  const { i18n, t } = useTranslation();
  const currentLanguageCode = i18n.language
  const DEFAULT = props.defaultValues;
  props.submitForm &&
    formik.submitForm() &&
    formik.validateForm &&
    props.handleSubmit(formik.values);
  const [opened, setOpened] = useState(false);
  const driver = props.driver;
  const formik = useFormik({
    initialValues: {
      education: DEFAULT?.education.code || "PGD",
      maritalStatus: DEFAULT?.maritalStatus?.code || "5",
      employer: DEFAULT?.employer || "Private Sector",
      occupation: DEFAULT?.occupation?.code || "1548",
      sourceOfIncome: DEFAULT?.sourceOfIncome || i18n.language == "ar" ? "الراتب" : "Salary",
      childrenUnderAge: DEFAULT?.childrenUnderSixteen?.code || "0",
      region: props?.driver?.regionCode || '1',
      licenseType: DEFAULT?.licenseType?.code || '1',
      accidentsInLastFiveYears: DEFAULT?.noOfAccidents || 0,
      claimsInLastFiveYears: DEFAULT?.noOfClaims || 0,
      roadConvictions: DEFAULT?.roadConvictions?.code || "NIL",
      medicalConditions: DEFAULT?.roadConvictions?.medicalConditions || '1',
      saudiLicenseHeldFor: DEFAULT?.licenseExperienceYears?.code || '1',
    },
    validate: (data) => {
      let errors = {};

      if (!data.idNumber) {
        errors.idNumber = "National ID is required.";
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.idNumber)) {
        errors.idNumber = "National ID is not valid";
      }
      if (!data.placeOfIssue) {
        errors.placeOfIssue = "Required";
      }
      if (!data.idType) {
        errors.idType = "Required";
      }
      if (!data.expireDate) {
        errors.expireDate = "Required";
      }
      return errors;
    },

    onSubmit: (data) => {
      ////     // console.log(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const getYobList = () => {
    return globalUtils.isSaudi(formik.values.nationalId)
      ? globalUtils.getHijriYearOfBirthList()
      : globalUtils.getGregYearOfBirthList();
  };

  return (
    <StyleWrapper className="mb-4">
      <div
        onClick={() => setOpened(!opened)}
        className={
          "accordion-header sub d-flex justify-content-between align-items-center " +
          (opened ? "opened" : "")
        }
      >
        <h5 className="fm-bliss2-bold mb-0">{(i18n.language === "ar" ? driver.araFullName : driver.engFullName) || (i18n.language === "ar" ? driver?.araFirstName : driver?.engFirstName)}</h5>
        <div className="Icon-Div">
          {opened ? (
            <i className="pi pi-chevron-up accordianIcon up-acc"></i>
          ) : (
            <i className="pi pi-chevron-down accordianIcon down-acc"></i>
          )}
        </div>
      </div>
      {opened && (
        <div className="infos-section">
          <form onSubmit={formik.handleSubmit} className="mt-4">
            <div className={"info-card form_card mb-4 " + props.className}>
              <div className="header">
                <h5>{currentLanguageCode == "en" ? "Other Policy Holder Information" : "معلومات أخرى عن حاملي الوثيقة "}</h5>
              </div>
              <Divider className="mb-3" />
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="licenseType"
                        name="licenseType"
                        value={formik.values.licenseType}
                        className={classNames({
                          "p-invalid": isFormFieldValid("licenseType"),
                        })}
                        onChange={formik.handleChange}
                        options={i18n.language === 'ar' ? config.LicenseTypeAr : config.LicenseType}
                        optionLabel="licenseTypeDescription"
                        optionValue="licenseTypeCode"
                        filter
                      />
                      <label htmlFor="licenseType">{currentLanguageCode == "en" ? "License Type" : "نوع الرخصة"}</label>
                    </span>
                    {getFormErrorMessage("licenseType")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="maritalStatus"
                        name="maritalStatus"
                        value={formik.values.maritalStatus}
                        className={classNames({
                          "p-invalid": isFormFieldValid("maritalStatus"),
                        })}
                        onChange={formik.handleChange}
                        options={globalConfig.martialStatusList}
                        optionLabel={i18n.language === 'ar' ? 'aName' : 'eName'}
                        optionValue="code"
                      />
                      <label htmlFor="maritalStatus">{currentLanguageCode == "en" ? "Marital Status" : "الحالة الاجتماعية"}</label>
                    </span>
                    {getFormErrorMessage("maritalStatus")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <InputText
                        value={formik.values.employer}
                        name="employer"
                        id="employer"
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": isFormFieldValid("employer"),
                        })}
                        placeholder=""
                      />
                      <label htmlFor="employer">{currentLanguageCode == "en" ? "Employer" : "صاحب العمل"}</label>
                    </span>
                    {getFormErrorMessage("employer")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="occupation"
                        name="occupation"
                        value={formik.values.occupation}
                        className={classNames({
                          "p-invalid": isFormFieldValid("occupation"),
                        })}
                        onChange={formik.handleChange}
                        options={i18n.language === 'ar' ? globalConfig.occupationListAr : globalConfig.occupationList}
                        filter showClear filterBy="name"
                        optionLabel="occupationDescription"
                        optionValue="occupationCode"
                      />
                      <label htmlFor="occupation">{currentLanguageCode == "en" ? "Occupation" : "المهنة"}</label>
                    </span>
                    {getFormErrorMessage("occupation")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="sourceOfIncome"
                        id="sourceOfIncome"
                        onChange={formik.handleChange}
                        value={formik.values.sourceOfIncome}
                        className={classNames({
                          "p-invalid": isFormFieldValid("sourceOfIncome"),
                        })}
                        placeholder=""
                      />
                      <label htmlFor="sourceOfIncome">{currentLanguageCode == "en" ? "Source of Income" : "مصدر الدخل"}</label>
                    </span>
                    {getFormErrorMessage("sourceOfIncome")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="childrenUnderAge"
                        name="childrenUnderAge"
                        value={formik.values.childrenUnderAge}
                        className={classNames({
                          "p-invalid": isFormFieldValid("childrenUnderAge"),
                        })}
                        onChange={formik.handleChange}
                        options={[
                          "0",
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                          "6",
                          "7",
                          "8",
                          "9",
                          "10",
                          "11",
                          "12",
                        ]}
                      />
                      <label htmlFor="childrenUnderAge">
                        {currentLanguageCode == "en" ? "Children under age 16" : "الأطفال تحت عمر 16"}
                      </label>
                    </span>
                    {getFormErrorMessage("childrenUnderAge")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="region"
                        name="region"
                        value={formik.values.region}
                        className={classNames({
                          "p-invalid": isFormFieldValid("region"),
                        })}
                        onChange={formik.handleChange}
                        options={globalConfig.regionDetails}
                        optionLabel="descriptionEn"
                        optionValue="regionCode"
                        filter
                      />
                      <label htmlFor="region">{currentLanguageCode == "en" ? "Region" : "المنطقة"}</label>
                    </span>
                    {getFormErrorMessage("region")}
                  </div>
                </div>
              </div>
            </div>

            <div className={"info-card form_card " + props.className}>
              <div className="header">
                <h5> {t("MotorEn.OtherLicenseInformation")}</h5>
              </div>
              <Divider className="mb-3" />
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="education"
                        name="education"
                        value={formik.values.education}
                        className={classNames({
                          "p-invalid": isFormFieldValid("education"),
                        })}
                        onChange={formik.handleChange}
                        options={globalConfig.educationList}
                        optionLabel="label"
                        optionValue="value"
                      />
                      <label htmlFor="education">{currentLanguageCode == "en" ? "Education" : "التعليم"}</label>
                    </span>
                    {getFormErrorMessage("education")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className={`p-float-label ${currentLanguageCode === 'ar' ? 'increment-decrement-ar' : 'increment-decrement-en'}`}>
                      <InputNumber
                        inputId="accidentsInLastFiveYears"
                        name="accidentsInLastFiveYears"
                        value={formik.values.accidentsInLastFiveYears}
                        onValueChange={formik.handleChange}
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        min={0}
                        decrementButtonClassName="p-button-danger"
                        incrementButtonClassName="p-button-success"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        className="z-index-0"
                      />
                      <label htmlFor="accidentsInLastFiveYears">
                        {currentLanguageCode == "en" ? "Accidents in last 5 years" : "الحوادث في السنوات الخمس الأخيرة"}
                      </label>
                    </span>
                    {getFormErrorMessage("accidentsInLastFiveYears")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className={`p-float-label ${currentLanguageCode === 'ar' ? 'increment-decrement-ar' : 'increment-decrement-en'}`}>
                      <InputNumber
                        inputId="claimsInLastFiveYears"
                        name="claimsInLastFiveYears"
                        value={formik.values.claimsInLastFiveYears}
                        onValueChange={formik.handleChange}
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        min={0}
                        decrementButtonClassName="p-button-danger"
                        incrementButtonClassName="p-button-success"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        className="z-index-0"
                      />
                      <label htmlFor="claimsInLastFiveYears">{currentLanguageCode == "en" ? "Claims in last 5 years" : "لمطالبات في 5 سنوات الأخيرة"}</label>
                    </span>
                    {getFormErrorMessage("claimsInLastFiveYears")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="roadConvictions"
                        name="roadConvictions"
                        value={formik.values.roadConvictions}
                        className={classNames({
                          "p-invalid": isFormFieldValid("roadConvictions"),
                        })}
                        onChange={formik.handleChange}
                        options={i18n.language === 'ar' ? globalConfig.RoadConvictionsAr : globalConfig.RoadConvictions}
                        optionLabel="roadConvictionDescription"
                        optionValue="roadConvictionCode"
                      />
                      <label htmlFor="roadConvictions">{currentLanguageCode == "en" ? "Road Convictions" : "إدانات الطريق"}</label>
                    </span>
                    {getFormErrorMessage("roadConvictions")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="medicalConditions"
                        name="medicalConditions"
                        value={formik.values.medicalConditions}
                        className={classNames({
                          "p-invalid": isFormFieldValid("medicalConditions"),
                        })}
                        onChange={formik.handleChange}
                        options={i18n.language === 'ar' ? globalConfig.MedicalConditionsAr : globalConfig.MedicalConditions}
                        optionLabel="medicalConditionsDescription"
                        optionValue="medicalConditionsCode"
                        filter
                      />
                      <label htmlFor="medicalConditions">
                        {currentLanguageCode == "en" ? "Medical Conditions" : "الحالة الصحية"}
                      </label>
                    </span>
                    {getFormErrorMessage("medicalConditions")}
                  </div>
                </div>
                <div className="col-md-6 col-12 mb-4">
                  <div className="field mt-2">
                    <span className="p-float-label">
                      <Dropdown
                        inputId="saudiLicenseHeldFors"
                        name="saudiLicenseHeldFor"
                        value={formik.values.saudiLicenseHeldFor}
                        className={classNames({
                          "p-invalid": isFormFieldValid("saudiLicenseHeldFor"),
                        })}
                        onChange={formik.handleChange}
                        options={i18n.language === 'ar' ? globalConfig.LicenseExperienceYearsAr : globalConfig.LicenseExperienceYears}
                        optionLabel="licenseExperienceYearsDescription"
                        optionValue="licenseExperienceYearsCode"
                      />
                      <label htmlFor="saudiLicenseHeldFor">
                        {currentLanguageCode == "en" ? "Saudi License Held For" : "احتجار الرخصة السعودية لمدة"}
                      </label>
                    </span>
                    {getFormErrorMessage("saudiLicenseHeldFor")}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </StyleWrapper>
  );
};

export default OtherDriverDetails;
